import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { DatabaseZap } from 'lucide-react';
import { API } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';
import { SelfImportCard } from '../../../components/admin/setup/SelfImportCard';
import { VendorImport } from '../purchasing/VendorImport';
import { ImportHistory } from '../../../components/admin/setup/ImportReport';

const CARDS = [
  ['customers', 'Customers and vehicles', 'Name is required. Phone, email, address, GSTIN and vehicle (registration, make, model) are optional.'],
  ['balances', 'Customer open balances', 'What each customer still owes from your old system. Each becomes an opening-balance invoice you can collect against.'],
  ['stock', 'Stock and parts', 'Part name is required. Part number, HSN, cost, selling price, GST % and current stock are optional.'],
];

export default function DataImportPage() {
  const { authHeader } = useAuth();
  const [st, setSt] = useState(null);
  const [tick, setTick] = useState(0);
  const load = useCallback(() => axios.get(`${API}/self-import/status`, { headers: authHeader() }).then((r) => setSt(r.data)).catch(() => setSt({ results: {}, counts: {} })), [authHeader]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="min-h-full space-y-5 bg-slate-50 p-4 sm:p-6" data-testid="data-import-page">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-100 text-teal-700"><DatabaseZap size={20} /></span>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Bring your data</h1>
          <p className="max-w-2xl text-sm text-slate-500">Move your records from your old software or Excel yourself. Your data stays private to your workshop. Download a template, or upload your own export and match the columns. Re-importing the same file merges instead of doubling.</p>
        </div>
      </div>
      {CARDS.map(([k, t, h]) => <SelfImportCard key={k} kind={k} title={t} hint={h} last={st?.results?.[k]} onDone={() => { load(); setTick((x) => x + 1); }} />)}
      <VendorImport onDone={() => { load(); setTick((x) => x + 1); }} />
      <ImportHistory refreshKey={tick} />
    </div>
  );
}
